import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsChangeDistanceBody,
  PostApplicationsChangeDistanceResponse,
} from "api/api/applicationsApi/types";

export const postApplicationsChangeDistance = createAsyncThunk<
  PostApplicationsChangeDistanceResponse,
  PostApplicationsChangeDistanceBody
>("applications/postApplicationsChangeDistance", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplicationsChangeDistance(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications change distance", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications change distance", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});